import React from 'react';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#0A0A0F]" data-id="element-0">
      <Hero data-id="element-1" />
      <HowItWorks data-id="element-2" />
      <Features data-id="element-3" />
      <Testimonials data-id="element-4" />
      <FAQ data-id="element-5" />
      <CTA data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}